export default __webpack_public_path__ + "static/media/GitHub-Mark.f4da2df7.svg";